import type { NotificationGroup } from "@porsche-customer/slfinrtl-notification-service-event-api"
import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { NotificationListItemStatus } from "./NotificationListItem"
import type { NotificationListView } from "./NotificationListView"

export interface GetNotificationListViewQueryParams {
	notificationGroup?: NotificationGroup
	statuses: NotificationListItemStatus[]
}

export const getNotificationListViewRoute: ApiRoute<
	NoPathParams,
	GetNotificationListViewQueryParams,
	NoBody,
	NotificationListView
> = {
	buildUrl: () => "/notification-list",
	method: "get",
	path: "/notification-list",
}
